import React, { Fragment } from 'react'
import { Spin } from 'antd'
import { multiSelectStyles } from './variable'
import ReactMultiSelectCheckboxes from 'react-multiselect-checkboxes'
import Loader from '../../../../../../components/Loader'

export default function RefferringClient({
  isEnable,
  isLoadingRefferingClient,
  ...props
}) {
  return (
    <Fragment>
      {isEnable && (
        <div className="form-group material-textfield">
          <Spin
            size="small"
            spinning={isLoadingRefferingClient}
            indicator={<Loader />}
          >
            <div className="multiselect__checkboxes__field">
              <ReactMultiSelectCheckboxes
                styles={multiSelectStyles}
                width="100%"
                name="refferringClient"
                placeholderButtonLabel="Select"
                // getDropdownButtonLabel={({ placeholderButtonLabel, value }) => {
                //   if (value.length > 0)
                //     return map(value, (val) => val.label).join(',')
                //   return 'Select'
                // }}
                value={props.selectedRefferringClient}
                options={props.refferringClientOption}
                inputValue={props.searchTerm}
                onInputChange={props.filterRefferClientsOption}
                onChange={props.handleRefferingClient}
              />
              <label className="multiselect__checkboxes__field__label">
                Referring Client
              </label>
            </div>
          </Spin>
        </div>
      )}
    </Fragment>
  )
}
